var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useRef, useState } from 'react';
import { useClipboard } from 'root/src/client/web/hooks/useClipboard';
import toast from 'react-hot-toast';
import { colorsNew } from 'root/src/client/web/commonStyles';
export const useToggleableCopyField = (text) => {
    const [isVisible, setIsVisible] = useState(false);
    const { writeText } = useClipboard();
    const inputRef = useRef(null);
    const onInputClick = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.select();
        yield writeText(text);
        toast.success('Copied to clipboard', {
            style: {
                backgroundColor: colorsNew.secondary,
                color: colorsNew.white,
            },
        });
    });
    const toggleIsVisible = () => setIsVisible(prev => !prev);
    return {
        isVisible,
        inputRef,
        onInputClick,
        toggleIsVisible,
    };
};
